import axios from 'axios';
import Config from '../actions/Config';
import AccessToken from '../actions/AccessToken';

const BASE_URL = Config();
const getResponse = {};
const token = AccessToken();

getResponse.GetBrandList = (endpoint, accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
} 

getResponse.AddNewBrand = (endpoint, accesstoken, details, callback) => {
    console.log("Request data", details);
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        data: details,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
} 

getResponse.GetBrandDetails = (endpoint, accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
} 

getResponse.EditBrand = (endpoint, accesstoken, details, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        data: details,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}

getResponse.UploadMedia = (endpoint, accesstoken, formData, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        data: formData,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
} 

getResponse.DeleteBrand = (endpoint, accessToken, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accessToken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}

getResponse.GetBrandFilesList = (endpoint, accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}

getResponse.DeleteFile = (endpoint, accesstoken, callback) => {
    axios({
        method: 'DELETE',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}

export default getResponse;
